import { cn } from '../../utils/cn';

export default function ProgressBar({
  value = 0,
  max = 100,
  label,
  showPercent = true,
  color = 'primary',
  size = 'md',
  className,
}) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  const colors = {
    primary: 'bg-primary-500',
    success: 'bg-success-500',
    warning: 'bg-warning-500',
    danger: 'bg-danger-500',
    gradient: 'bg-gradient-to-r from-primary-500 to-primary-700',
  };
  const sizes = { sm: 'h-1.5', md: 'h-2', lg: 'h-3' };

  return (
    <div className={cn('w-full', className)}>
      {(label || showPercent) && (
        <div className="mb-1 flex justify-between text-xs text-neutral-600">
          {label && <span>{label}</span>}
          {showPercent && <span className="font-medium">{Math.round(pct)}%</span>}
        </div>
      )}
      <div className={cn('w-full overflow-hidden rounded-full bg-neutral-100', sizes[size])}>
        <div
          className={cn('h-full rounded-full transition-all', colors[color] || colors.primary)}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
